import React from 'react';

import { useAppSelector } from '@/store';
import { Services } from '@/components/pages/Subscription/Presentation/Form/Field/Services';
import { organizationServiceStore } from '@/store/organization/service';

type Props = {
  value: number[];
  refillServiceIds: (serviceId: number) => void;
  pushServiceIds: (serviceId: number) => void;
  pruneServiceIds: (serviceId: number) => void;
  serviceGroupId: number | null;
  error?: string | (string | undefined)[];
};

export const ServicesConatiner: React.FC<Props> = (props) => {
  const services = useAppSelector(
    organizationServiceStore.selectors.servicesSelector,
  );

  return <Services {...props} services={services} />;
};
